import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  // Switch,
  Divider,
  Typography,
} from "@mui/material";
import {
  Logout,
  // DarkMode,
  // LightMode,
  AccountCircle as AccountCircleIcon,
  Help as HelpOutlineIcon,
} from "@mui/icons-material";
import { logout } from "@smfa/utils/src";
import { persistor } from "../store";
//import { AppContext } from "../context";
import trainingManual from "../assets/img/User Manual for SMFA Admin Console.pdf";

// Assets
import logo from "../assets/img/logo.png";

/**
 * Site Header
 * @returns {JSX}
 * @component
 */
const Header = (props) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  //const user = useSelector((state) => state.user);
  //const { mode, toggleColorMode } = useContext(AppContext);

  // Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => logout(dispatch, { persistor });

  const handleOpenDocumentation = () => {
    window.open(trainingManual, "_blank");
    handleCloseMenu(); // Close the menu after clicking
  };

  // Separate handler for dark mode toggle to prevent event propagation issues
  // const handleThemeToggle = (event) => {
  //   event.stopPropagation(); // Prevent MenuItem onClick from firing
  //   toggleColorMode();
  // };

  return (
    <AppBar
      position="fixed" // fixed to stay at the top
      color="default"
      elevation={2} // elevation for better visibility
      sx={{
        backgroundColor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.drawer + 1, // above the sidebar
        width: "100%",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>
        {/* Logo */}
        <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="logo" style={{ height: "40px" }} />
          <Typography variant="h6" sx={{ marginLeft: 3, opacity: 0.7 }}>
            Admin
          </Typography>
        </Box>

        {/* Right side elements */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* User profile menu */}
          <IconButton
            onClick={handleOpenMenu}
            aria-controls={open ? "user-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            size="large"
            sx={{
              px: 1,
              py: 0,
            }}
          >
            <AccountCircleIcon
              fontSize="large"
              sx={{
                width: 35,
                height: 35,
              }}
            />
          </IconButton>

          {/* User dropdown menu */}
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            MenuListProps={{
              "aria-labelledby": "user-button",
            }}
            PaperProps={{
              elevation: 2,
              sx: {
                minWidth: 200,
                mt: 1.5,
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {/* Username display */}
            <MenuItem disabled sx={{ opacity: 1 }}>
              <ListItemText
                primary={auth?.user?.email || "User"}
                primaryTypographyProps={{ fontWeight: "medium" }}
              />
            </MenuItem>

            <Divider />

            {/* Dark mode toggle - fixed to prevent event conflicts */}
            {/* <MenuItem>
              <ListItemIcon>
                {mode === "dark" ? (
                  <LightMode fontSize="small" />
                ) : (
                  <DarkMode fontSize="small" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={`${mode === "dark" ? "Light" : "Dark"} Mode`}
              />
              <Switch
                edge="end"
                checked={mode === "dark"}
                onChange={handleThemeToggle}
                onClick={(e) => e.stopPropagation()}
                size="small"
              />
            </MenuItem> */}

            {/* HELP */}
            <MenuItem onClick={handleOpenDocumentation}>
              <ListItemIcon>
                <HelpOutlineIcon />
              </ListItemIcon>

              <ListItemText primary={"Help Documentation"} />
            </MenuItem>

            {/* Logout option */}
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
